import React, { Component } from "react";
import Layout from "../../HOC/Layput/Layout";
import Form from "react-bootstrap/Form";
import { Row, Col, Button } from "react-bootstrap";
import * as actions from "../../Store/Actions/index";
import "./PublishWithUs.css";
import { connect } from "react-redux";
import Spinner from '../../Components/UI/Spinner/Spinner'
class Publish extends Component {
  state = {
    cvFile: "",
    scriptFile: "",
    CV: "",
    script: "",
    name: "",
    email: "",
    phone: 0,
    currentOccupation: "",
    subjects: ""
  };
  componentWillMount() {
    this.props.getSubject();
  }
  uploadedFile = event => {
    var filename = event.target.value.replace(/^.*[\\\/]/, "");
    // console.log(event.target.files);/
    this.setState({
      cvFile: event.target.files[0],
      CV: filename
    });
  };
  uploadedScript = event => {
    var filename = event.target.value.replace(/^.*[\\\/]/, "");
    this.setState({
      scriptFile: event.target.files[0],
      script: filename
    });
  };

  saveData = event => {
    const { name, value } = event.target;
    this.setState({
      [event.target.name]: event.target.value
    });
  };

  sumbitData = () => {
    let formData = new FormData();
    formData.append('full_name', this.state.name);
    formData.append('email', this.state.email);
    formData.append('phone', this.state.phone);
    formData.append('current_occupation', this.state.currentOccupation);
    formData.append('subject_name', this.state.subjects);
    formData.append('cv_file', this.state.cvFile);
    formData.append('manuscript_path', this.state.scriptFile);

    // let payload = {
    //   full_name: this.state.name,
    //   email: this.state.email,
    //   phone: this.state.phone,
    //   current_occupation: this.state.currentOccupation,
    //   subject_name: this.state.subjects,
    //   cv_file: this.state.cvFile,
    //   manuscript_path: this.state.scriptFile
    // };
    this.props.publishWithUs(formData);
  };

  render() {
  document.title = "VK Global Publications | Publish With Us"

    let loader = this.props.loading ? <Spinner /> : ''
    return (
      <div>
        {loader}
        <Form>
          <Form.Group controlId="formBasicEmail">
            <Form.Label>Email address</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter email"
              name="email"
              onChange={this.saveData}
            />
          </Form.Group>
          <Row>
            <Col md={6}>
              <Form.Group controlId="formBasicPassword">
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Name"
                  name="name"
                  onChange={this.saveData}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="formBasicPassword">
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Phone"
                  name="phone"
                  onChange={this.saveData}
                />
              </Form.Group>
            </Col>
          </Row>
          <Form.Group controlId="formBasicEmail">
            <Form.Label>Current Occupation</Form.Label>
            <Form.Control
              type="text"
              placeholder="Current Occupation"
              name="currentOccupation"
              onChange={this.saveData}
            />
          </Form.Group>
          <Form.Group controlId="exampleForm.ControlSelect1">
            <Form.Label> Choose Subject</Form.Label>
            <Form.Control as="select" name="subjects" onChange={this.saveData}>
              <option selected disabled>
                Choose Subject
              </option>
              {this.props.subjectList.map((subject, index) => {
                return <option key={index}>{subject.subject_name}</option>;
              })}
            </Form.Control>
          </Form.Group>
          <div className="upload-btn-wrapper col-md-6 col-lg-6">
            <button className="uploadBtn">
              <i className="icon dripicons-paperclip"></i> Attach CV
            </button>
            <input
              id="fileInput"
              type="file"
              name="cv"
              onChange={event => this.uploadedFile(event)}
              accept="application/pdf,application/vnd.ms-excel"
            />
            <span>{this.state.CV}</span>
          </div>
          <div className="upload-btn-wrapper col-md-6 col-lg-6">
            <button className="uploadBtn scriptButton">
              <i className="icon dripicons-pencil"></i>Manuscript
            </button>
            <input
              id="fileInputScript"
              type="file"
              name="script"
              onChange={event => this.uploadedScript(event)}
              accept="application/pdf,application/vnd.ms-excel"
            />
            <span>{this.state.script}</span>
          </div>
        </Form>
        <Button className="submitBtn mt-4" onClick={this.sumbitData}>
          Submit
        </Button>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    subjectList: state.filterMenu.subjectList,
    loading:state.book.loading,
  };
};

const mapDispatchToprops = dispatch => {
  return {
    getSubject: () => dispatch(actions.fetchSubjectsList()),
    publishWithUs: postUserData => dispatch(actions.publishWithUs(postUserData))
  };
};

export default Layout( connect(mapStateToProps, mapDispatchToprops)(Publish)," Publish With Us ");
